export default __webpack_public_path__ + "static/media/otp-verification-success-icon.297f7947.svg";